export default "__VITE_ASSET__UiZbz9SO__"